import styled, {keyframes} from 'styled-components';
import {interceptProps} from '@/styled-components';
import {FULL_SCREEN, getHexWithOpacity, palette, Z_INDEX} from '@/styles';

const fadeIn = keyframes`
  0%   {opacity: 0;}
  100% {opacity: 1;}
`;

export const Backdrop = styled('div').withConfig({
  shouldForwardProp: interceptProps(['backdropColor', 'zIndex']),
})<{
  backdropColor?: string;
  zIndex?: number;
}>`
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: ${({zIndex}) => zIndex || Z_INDEX.modal};
  background-color: ${({backdropColor}) =>
    backdropColor || getHexWithOpacity(palette.black, 0.7)};
  animation: 200ms ${fadeIn} linear;
`;

export const ModalContainer = styled('div').withConfig({
  shouldForwardProp: interceptProps(['zIndex']),
})<{
  zIndex?: number;
}>`
  position: fixed;
  z-index: ${({zIndex}) => zIndex || Z_INDEX.modal};
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow-y: auto;
  width: 100%;
  height: 100%;
  max-height: ${FULL_SCREEN.vh};
  padding: 16px;
`;
